<template>
    <el-form ref="form" :model="value" label-position="top" :rules="rules">
        <Panel title="组件配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item label="f1" prop="f1">
                        <el-input v-model="value.f1"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item label="f2" prop="f2">
                        <el-input v-model="value.f2"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
        <Panel title="高级配置" collapse>
            <el-row>
                <el-col :span='12'>
                    <el-form-item label="f3" prop='f3'>
                        <el-input v-model="value.f3"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item label="f4" prop='f4'>
                        <el-input v-model="value.f4"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>

<script>
export default {
    props: {
        // String userConfig;
        // String userCertDir;
        // int signKeyIndex;
        // String rootCertDir;
        value: Object,
        init: Boolean
    },
    data: () => ({
        rules: {
            f1: [{required: true, message: "这是必填字段"}],
            f2: [{required: true, message: "这是必填字段"}],
        }
    }),
    mounted() {
        if (this.init) {
            this.$set(this.value, 'f3', '默认值3');
            this.$set(this.value, 'f4', '默认值4');
        }
    },
    methods: {
        validate() {
            return this.$refs.form.validate();
        },
    }

}
</script>

<style scoped>

</style>